import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Categorise: FC<IIconsProps> = ({
  color,
  fillcolor,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  if (!fillcolor) {
    color = theme.palette.neutral['00'];
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="8"
        height="8"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="2"
        y="14"
        width="8"
        height="8"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="14"
        y="2"
        width="8"
        height="8"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="17" y="13" width="2" height="10" rx="1" fill={fillcolor} />
      <rect
        x="23"
        y="17"
        width="2"
        height="10"
        rx="1"
        transform="rotate(90 23 17)"
        fill={fillcolor}
      />
    </svg>
  );
};

export default Categorise;
